<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_desired_map' | translate: lang }}</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="row">

    <div class="maps">
      <div class="rank-select-item" (click)="onSelect('Basalt')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/basalt.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Edin')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/edin.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Train')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/train.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Overpass')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/overpass.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Vertigo')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/vertigo.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Anubis')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/anubis.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Ancient')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/ancient.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Nuke')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/nuke.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Mirage')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/mirage.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Inferno')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/inferno.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Dust2')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/dust2.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Office')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/office.webp' | cdn}}" alt="">
      </div>

      <div class="rank-select-item" (click)="onSelect('Italy')">
        <img height="160" src="{{'https://cdn.ggboost.com/images/cs2/maps/italy.webp' | cdn}}" alt="">
      </div>
    </div>

  </div>
</div>